import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux_toolkit/store';
import ErrorPage from './containers/error/ErrorPage';
import ReloadHandler from './components/ReloadHandler';
import BeforeUnloadGuard from './components/BeforeUnroadGuard';

const rootElement = document.querySelector('#root');

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <ReloadHandler>
          <BeforeUnloadGuard />
          <App />
        </ReloadHandler>
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
  rootElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
